import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const vmray = defineConnector({
  identifier: "vmray",
  name: "VMRay",
  tagLine: "Automated malware analysis",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.vmray\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "Authorization", value: app.secret.apiKey, scheme: "api_key" },
    ]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In VMRay, navigate to your user profile and generate an API key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "VMRay endpoint",
          placeholder: "cloud.vmray.com",
          required: false,
          target: { kind: "configuration", field: "endpoint" },
          helperText: "For on-prem deployments. Defaults to cloud.vmray.com.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ endpoint }) => {
      const host = endpoint || "cloud.vmray.com";
      return `https://${host}/rest/system_info`;
    },
  },
  publicEnvVars: ({ endpoint }) => ({
    VMRAY_URL: `https://${endpoint || "cloud.vmray.com"}`,
  }),
});
